import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';


const routes: Routes = [
  { path: 'admin', loadChildren: 'app/admin/admin.module#backendModule' },
 // { path: '', loadChildren: 'app/admin/admin.module#backendModule' },
  { path: '', loadChildren: 'app/frontend/frontend.module#FrontendModule' },
 
  
  ];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);


// WEBPACK FOOTER //
// D:/PROJECTS/ANGULAR2_PROJECT/WEB/raspab/src/app/app.routing.ts